/// <amd-module name="Search/WorkItem/Flux/ActionsHub" />
import { Action } from "VSS/Reflux/Action";
import * as BaseActionsHub from "Search/Shared/Base/ActionsHub";
import { WorkItemSearchRequest, WorkItemSearchResponse, WorkItemResult } from "Search/LegacyWebApi/Contracts/WorkItem";
import { WorkitemPreviewPaneScenario } from "Search/WorkItem/Flux/Stores/PreviewNotificationStore";

export interface IActiveTabChangedPayload {
    activeTabKey: string;
}

export class ActionsHub extends BaseActionsHub.ActionsHub<WorkItemSearchRequest, WorkItemSearchResponse, WorkItemResult> {
    public showPreviewMessageBanner = new Action<WorkitemPreviewPaneScenario>();
    public dismissPreviewMessageBanner = new Action();
}
